import { Injectable } from "@angular/core";
import { ConfigProvider } from "../config/config";

@Injectable({providedIn:'root'})
export class AppDetectorProvider {
    appId: string = "";
    isClient: boolean = false;


    constructor(private config: ConfigProvider) {
        new Promise(async (resolve, reject) => {
            this.appId = (await config.config).appId;
            this.isClient = ((await config.config).client) ? true : false;
        });
    }

    isConfiguratorApp(): boolean {
        return this.appId.includes('configurator') ? true : false;
    }

    isGesunderApp(): boolean {
        return this.appId.includes('gesunder') ? true : false;
    }

    isHellaApp(): boolean {
        return this.appId.includes('hella') ? true : false;
    }

    isLeaderBoardApp(): boolean {
        return this.appId.includes('leaderboard') ? true : false;
    }

    isForestApp(): boolean {
        return (this.appId.includes('sportevents')) ? true : false;
    }

    isEventsApp(): boolean {
        return (this.appId.includes('event') && !this.isClient) ? true : false;
    }

    isSpooortsApp(): boolean {
        return this.appId.includes('eventsoriginal') ? true : false;
    }

    isThurnauApp(): boolean {
        return this.appId.includes('thurnau') ? true : false;
    }

    isHannoverApp(): boolean {
        return this.appId.includes('hannover') ? true : false;
    }

    isTournamentApp(): boolean {
        return this.appId.includes('tournament') ? true : false;
    }
}
